import { render, staticRenderFns } from "./DataTableCellDesktop.vue?vue&type=template&id=d5ec5704&scoped=true&"
import script from "./DataTableCellDesktop.vue?vue&type=script&lang=ts&"
export * from "./DataTableCellDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableCellDesktop.vue?vue&type=style&index=0&id=d5ec5704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ec5704",
  null
  
)

export default component.exports